import WeAreHome from './WeAreHome';
export default WeAreHome;
